import { render, staticRenderFns } from "./BaseAlert.vue?vue&type=template&id=70b0a78b&"
import script from "./BaseAlert.vue?vue&type=script&lang=js&"
export * from "./BaseAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b0a78b')) {
      api.createRecord('70b0a78b', component.options)
    } else {
      api.reload('70b0a78b', component.options)
    }
    module.hot.accept("./BaseAlert.vue?vue&type=template&id=70b0a78b&", function () {
      api.rerender('70b0a78b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseAlert.vue"
export default component.exports